import { Component, Input } from '@angular/core';
import { UserVerificationProvider } from '../../providers/user-verification/user-verification';

@Component({
  selector: 'verification-short-prompt',
  templateUrl: 'verification-short-prompt.html',
})
export class VerificationShortPromptComponent {
  constructor(public verification: UserVerificationProvider) {}

  ngOnInit() {}

  getVerified() {
    this.verification.showGetVerifiedOverlay();
  }
}



// WEBPACK FOOTER //
// ./src/components/verification-short-prompt/verification-short-prompt.ts